import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { StageType } from 'modules/championship/domain/enums/stage-type';
import { StageV2 } from 'modules/championship/domain/interfaces/stage';
import { selectSelectedStageGroups } from 'modules/championship/store/stages';
import { StageBracketsForm } from './stage-brackets';
import CreateStageGroupForm, { CreateStageGroupFormHandle } from './stage-group/create-stage-group-form';
import StageGroupList from './stage-group/stage-group-list';

interface StageGridProps {
  stage: StageV2;
}

/**
 * «Сетка матчей» для этапов без под-сегментов: группы и плей-офф. Круговые этапы
 * с их «Таблицей» и «Шахматкой» разводит `stage-grid-routes.tsx`.
 */
const StageGrid = ({ stage }: StageGridProps) => {
  const teamGroups = useSelector(selectSelectedStageGroups);
  const isGroupStage = stage.type === StageType.GROUP;
  const formRef = useRef<CreateStageGroupFormHandle>(null);

  if (isGroupStage) {
    return (
      <div className="row gap-y-5">
        <CreateStageGroupForm ref={formRef} stage={stage} />

        <StageGroupList groups={teamGroups} teams={stage.teams} onAddGroupClick={() => formRef.current?.focus()} />
      </div>
    );
  }

  return (
    <div className="row gap-y-5">
      <StageBracketsForm teams={stage.teams} />
    </div>
  );
};

export default StageGrid;
